import * as api from "@/apiv2/uiInteractions";
import { createAction, createSetterActions } from "@/redux/helpers/action";

import { MODULE } from "./constants";
import * as selectors from "./user-ui-interactions.selectors";

export const [setInteractions] = createSetterActions(MODULE, ["interactions"]);

export const reset = createAction(`${MODULE}/RESET`);

// Remembering a preference is a background nicety. If the call fails the user
// still gets the behaviour they asked for in this session, so log it and move
// on rather than throwing a red toast at them (handleError would do both).
const logFailure = (error) => {
  console.error("User UI interactions request failed", error);
};

// Save one element's state for this user. The endpoint replaces the whole map,
// so merge the new entry over what we already hold and send the result. We
// update the store first so the UI never waits on the network.
//
// The API layer snake_cases request bodies, which leaves our already-snake_case
// keys exactly as they are.
export const recordUserInteraction = (payload) => async (dispatch, getState) => {
  const interactions = { ...(selectors.getInteractions(getState()) ?? {}), ...payload };
  dispatch(setInteractions(interactions));

  try {
    await api.postUserUiInteractions({ ui_interactions: interactions })();
  } catch (error) {
    logFailure(error);
  }
};
